module.exports = __webpack_public_path__ + "static/img/fish43.821b2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish43.png
// module id = 0kAR
// module chunks = 0